import _ from 'lodash';

export default {
  computed: {
    fullyLoaded() {
      return _.every(this.$asyncComputed, { updating: false, success: true });
    },
  },
  methods: {
    fullyLoadedButAsAMethodBecauseSometimesComputedDoesNotWork() {
      return _.every(this.$asyncComputed, { updating: false, success: true });
    },
    asyncComputedShouldUpdate() {
      return true;
    },
  },
  beforeRouteLeave(to, from, next) {
    this.asyncComputedShouldUpdate = () => {
      return false;
    };
    next();
  },
};
